export const SWITCH_MODE = 'SWITCH_MODE';
export const MAKE_LOADING = 'MAKE_LOADING';
export const MAKE_FAILURE = 'MAKE_FAILURE';
export const SWITCH_LINE_SUCCESS = 'SWITCH_LINE_SUCCESS';
export const CHANGE_RANGE_SUCCESS = 'CHANGE_RANGE_SUCCESS';
export const CHANGE_AXES = 'CHANGE_AXES';
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';